import Task from './TaskNode'
import { Graph,Path } from '@antv/x6'
import '@antv/x6-vue-shape'
Graph.registerNode(
  'dag-node',
  {
    inherit: 'vue-shape',
    width: 180,
    height: 36,
    component: {
      template: `<Task />`,
      components: {
        Task
      }
    },
    ports: {
      groups: {
        top: {
          position: 'top',
          attrs: {
            circle: {
              r: 4,
              magnet: true,
              stroke: '#C2C8D5',
              strokeWidth: 1,
              fill: '#fff'
            }
          }
        },
        bottom: {
          position: 'bottom',
          attrs: {
            circle: {
              r: 4,
              magnet: true,
              stroke: '#C2C8D5',
              strokeWidth: 1,
              fill: '#fff'
            }
          }
        }
      }
    }
  },
  true
)

Graph.registerEdge(
  'dag-edge',
  {
    inherit: 'edge',
    router: {
      name: 'orth',
      args: {
        side: 'top',
      },
    },

    attrs: {
      line: {
        stroke: '#000',
        strokeWidth: 1,
        // targetMarker: null
      }
    }
  },
  true
)

Graph.registerConnector(
  'algo-connector',
  (s, e) => {
    const offset = 4
    const deltaY = Math.abs(e.y - s.y)
    const control = Math.floor((deltaY / 3) * 2)

    const v1 = { x: s.x, y: s.y + offset + control }
    const v2 = { x: e.x, y: e.y - offset - control }

    return Path.normalize(
      `M ${s.x} ${s.y}
        L ${s.x} ${s.y + offset}
        C ${v1.x} ${v1.y} ${v2.x} ${v2.y} ${e.x} ${e.y - offset}
        L ${e.x} ${e.y}
        `
    )
  },
  true
)


export default function (dom, minimapContainer) {
  let graph = new Graph({
    container: dom,
    snapline: true,  //设置对齐线
    autoResize: true,
    background: {
      color: '#fffbe6' // 设置画布背景颜色
    },
    grid: {
      size: 10, // 网格大小 10px
      visible: true // 渲染网格背景
    },
    panning: {
      enabled: true,
      eventTypes: ['leftMouseDown', 'mouseWheel']
    },
    mousewheel: {
      enabled: true,
      modifiers: 'ctrl',
      factor: 1.1,
      maxScale: 1.5,
      minScale: 0.5
    },
    highlighting: {
      magnetAdsorbed: {
        name: 'stroke',
        args: {
          attrs: {
            fill: '#fff',
            stroke: '#31d0c6',
            strokeWidth: 4
          }
        }
      }
    },
    connecting: {
      snap: true,
      allowBlank: false,  //是否允许连接到画布空白位置的点，默认为 true。
      allowLoop: false,
      highlight: true,
      // allowNode:true, 是否允许边链接到节点（非节点上的链接桩），默认为 true。
      // allowPort:true, 是否允许边链接到链接桩，默认为 true。
      connector: 'algo-connector',  //线类型
      connectionPoint: 'anchor',    // anchor 指定连接点，默认值为 boundary。
      anchor: 'center',  //当连接到节点时，通过 anchor 来指定被连接的节点的锚点，默认值为 center。
      
      validateMagnet({ magnet }) {
        return magnet.getAttribute('port-group') !== 'top'
      },
      createEdge() {
        return graph.createEdge({
          shape: 'dag-edge',
          attrs: {
            line: {
              strokeDasharray: '5 5'
            }
          },
          zIndex: -1
        })
      }
    },
    selecting: {
      enabled: true,
      multiple: true,
      rubberEdge: true,
      rubberNode: true,
      modifiers: 'shift',
      rubberband: true,    // 启用框选
     
      // className: 'my-selecting',
      // showEdgeSelectionBox:false, //是否显示边选择框
      // showNodeSelectionBox:true, //是否显示节点框选边框
      // pointerEvents:true,
      // multipleSelectionModifiers:'ctrl',
    },

    // scroller: {
    //   enabled: true,
    // },
    // minimap: {
    //   enabled: true,
    //   container: minimapContainer,
    // }
  })
  return graph;
}